import { runClientComponent } from '../../_common/client/client-component-runner';
import { QuickAccessComponent } from './quick-access.component';

runClientComponent({ QuickAccessComponent });
